import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  cardWrapper: {
    margin: '24px 40px',
    padding: '20px'
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    margin: '10px 40px 24px',
  },
  container: {
    border: '1px solid #70707033',
  },
  heading: {
    backgroundColor: '#F7F7F7',
    padding: '0.75rem 0.5rem',
    color: '#F37320',
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '16px',
  },
  content: {
    margin: '15px',
    fontSize: '14px',
    cursor: 'pointer',
    color: '#4A4A4A'
  },
  bold: {
    fontWeight: 800,
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '37px'
  },
  formContainer: {
    margin: '40px',
  },
  buttonContainer: {
    display: 'flex',
    marginTop: '20px'
  },
  button: {
    maxWidth: 220,
  },
  primaryButton: {
    color: 'white',
    marginRight: '20px'
  },
  userHeaderWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 20px',
  },
  formButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px'
  },
  summaryCard: {
    margin: '20px 10px',
    minHeight: '80px',
    padding: '5px'
  },
  summaryGrid: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px',
    cursor: 'pointer',
  },
  notSelected: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '200px',
    color: '#F37320',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'center'
  },
  formHeading: {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '15px 0',
    color: '#4A4A4A'
  },
  formSubHeading: {
    fontSize: '14px',
    color: '#4A4A4A'
  },
  reportForm: {
    '@media (max-width: 959px)': {
      margin: '1rem 0.5rem',
    },
  },
  mr2: {
    marginRight: '2rem',
    marginBottom: '10px',
    display: 'inline-block'
  },
  dateWrapper: {
    display: 'flex',
    justifyContent: 'end',
    maxWidth: '500px',
    position: 'relative'
  },
  input: {
    '@media (min-width: 3000px)': {
      '& svg': {
        top: 'calc(50% - 25px)'
      }
    }
  },
  buttons: {
    width: 'auto',
    margin: '10px 0'
  },
  mr4: {
    marginRight: '10px',
  },
}))

export { useStyles }